import React, { Component } from 'react'

import { FlexContainer } from '../../styles/defaults'
import Detail from '../../components/Detail/'

class Details extends Component {
  render() {
    Object.keys(this.props.branch).map((key, index) => {
      if (this.props.branch[key] === null) {
        this.props.branch[key] = ''
      }
      return null
    })

    const {
      name,
      phone,
      altPhone,
      email,
      website,
      address,
      zipcode,
      city,
      billingAddress,
      billingZipcode,
      billingCity,
      accountNumber,
      servicePackage
    } = this.props.branch
    const details = {
      contact: [
        {
          title: 'Naam',
          content: name,
          subcontent: '',
          href: ''
        },
        {
          title: 'Telefoon',
          content: phone,
          subcontent: '',
          href: `tel:${phone}`
        },
        {
          title: 'Telefoon #2',
          content: altPhone,
          subcontent: '',
          href: ''
        },
        {
          title: 'E-mail',
          content: email,
          subcontent: '',
          href: `mailto:${email}`
        },
        {
          title: 'Website',
          content: website,
          subcontent: '',
          href: `http://${website}`
        }
      ],
      address: [
        {
          title: 'Adres',
          content: address,
          subcontent: zipcode + ' ' + city,
          href: ''
        },
        {
          title: 'Factuuradres',
          content: billingAddress,
          subcontent: billingZipcode + ' ' + billingCity,
          href: ''
        }
      ],
      invoice: [
        {
          title: 'Servicepakket',
          content: servicePackage,
          subcontent: '',
          href: '/servicepakketten'
        },
        {
          title: 'Ten name van',
          content: name,
          subcontent: '',
          href: ''
        },
        {
          title: 'IBAN',
          content: accountNumber || 'Onbekend',
          subcontent: '',
          href: ''
        }
      ]
    }

    return (
      <FlexContainer full mg3>
        <Detail
          title="Contactgegevens"
          items={details.contact}
          formFields={this.props.formFields}
          updateBranch={this.props.updateBranch}
          data={this.props.data}
          loading={this.props.loading}
          error={this.props.error}
          id={this.props.id}
        />
        <Detail title="Adresgegevens" items={details.address} />
        <Detail title="Bestelgegevens" items={details.invoice} />
      </FlexContainer>
    )
  }
}

export default Details



// WEBPACK FOOTER //
// ./src/containers/Details/index.js